// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IlAV","label":"styles_label__2k3A_"};